<div class="system-info" style="white-space:nowrap; padding-bottom:5px;">
    <span><label>{{OnHandLabel}}:</label>&nbsp;{{inventory.RollBalance}} {{inventory.BaseUOM}}</span>
    <span *ngIf="adjustmentAmount" style="margin-left:1em;">Adjust: {{adjustmentAmount | signed}}
        {{inventory.BaseUOM}}</span>
</div>

<div>
    <span style="width: 95%; font-size:0.9em; line-height:1.1; text-align:center; color: red;"
        [style.display]="inventory.AdjustmentAcceptable ? 'none' : 'inline-block'">
        Adjustment quantity exceeds<br />acceptable range</span>
</div>

<div>
    <table>
        <tr>
            <td>
                <label>Adjust to:<br />
                    <p style="display:inline-block; text-decoration: italic;" *ngIf="required">*Required*</p>
                </label>
            </td>
            <td>
                <mat-form-field appearance="fill" style="width:9em;">
                    <mat-label>Actual</mat-label>
                    <input #adjustRemainingOnHandInput [(ngModel)]="adjustRemainderTo" inputmode='quantity' matInput
                        [required]="required" (keydown.enter)="onEnterKey.emit()" (blur)="onAdjustToQtyBlur()"
                        [disabled]="disabled" />
                    <button mat-icon-button matSuffix (click)="adjustRemainderTo = null"
                        *ngIf="inventory.AdjustmentQty !== undefined">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-form-field>
            </td>
        </tr>
    </table>
</div>
<!-- 
<div class="system-info" style="white-space:nowrap;">
    <label>Adjustment: </label>
    <span *ngIf="adjustmentAmount">{{adjustmentAmount | signed}} {{inventory.BaseUOM}}</span>
    <span *ngIf="!adjustmentAmount">(none)</span>
</div> -->